module.exports = __webpack_public_path__ + "img/DSC_7050.263429c8.jpg";